import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { ROUTE_SALE_MILES } from "../../shared/constants";

class NoOffers extends Component {
	constructor() {
		super();
		this.state = {};
	}

	render() {
		return (
			<section className="no-offers row">
				<div className="block-center">
					<div className="no-offers--image" />
					<p className="no-offers--title">Nenhuma oferta ativa :(</p>
					<p className="no-offers--description">
						Adicione agora sua primeira oferta <br />e comece a vender com a gente!
					</p>

					<NavLink
						className="btn btn-primary"
						data-action="no-offers-add-offer"
						to={ROUTE_SALE_MILES}
						onClick={() => {
							window.location.href = window.location.origin + ROUTE_SALE_MILES;
						}}
					>
						Adicionar oferta
					</NavLink>
				</div>
			</section>
		);
	}
}

export default NoOffers;
